import React from 'react';
import { styled } from 'linaria/react';

import { cx } from 'linaria';
import { theme } from '../../Theme';

const List = styled('ul')`
  position: absolute;
  top: 0;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  height: inherit;

  &.left {
    left: 16px;
    justify-content: flex-start;
    /* button {
      padding: 0 8px;
    } */
  }
  &.right {
    right: 16px;
    justify-content: flex-end;

    /* ${theme.below.lg} {
      padding-right: 10px;

      li {
        padding-left: 0!important;
      }
    } */
  }

  button {
    border: none;
  }
  /* 
  ${theme.below.sm} {
    &.left {
      li {
        padding: 0 2px;

        &:last-of-type {
          padding-right: 8px;
        }
      }
    }
  } */
`;

const ListItem = styled('li')`
  list-style: none;
  display: block;
`;

const TopNav = ({ children, left, ...rest }) => (
  <List {...rest} className={cx(left ? 'left' : 'right')}>
    {React.Children.map(children, (item) => (
      <ListItem>{item}</ListItem>
    ))}
  </List>
);

export default TopNav;
